import { FC } from 'react';
import { Text, VStack, Flex, Icon } from '@chakra-ui/react';
import icons from 'shared/icons';

const ALinkableCard: FC<{ title: string; value: string; link?: boolean; [x: string]: any; path?: string }> = ({
    title,
    value,
    children,
    link,
    path,
    ...rest
}) => {
    const ArrowIcon = icons.arrowGo;
    return (
        <VStack
            borderRadius="16px"
            boxShadow="base"
            alignItems="flex-start"
            justifyContent="space-between"
            width="306px"
            bg="white"
            p={6}
            {...rest}
            cursor={link ? 'pointer' : 'auto'}
            onClick={() => {
                if (link && path) {
                    window.location.href = path;
                }
            }}
        >
            <Flex w="100%" alignItems="center" justifyContent="space-between">
                <Text color="gray.500" fontSize="md" fontWeight="700">
                    {title}
                </Text>
                {link && <Icon color="blue" w="18px" h="18px" as={ArrowIcon} />}
            </Flex>

            <Text fontSize="2xl" fontWeight="400" color="gray.700">
                {value}
            </Text>
            {children}
        </VStack>
    );
};

export default ALinkableCard;
